module.exports = __webpack_public_path__ + "static/media/CbcSport_Azerbaijan.7b9f7c02.png";